ui-cms-slide {
  display: block;
}
